import { ScoreBreakdownCategories } from '../../../apiHooks/useScoreBreakdownByUserQuery';
import type { SVGRSvg } from '../../../lib/types/SVGRSvg';
import CompletionIcon from '../assets/behaviors/completion.svg';
import KnowledgeIcon from '../assets/behaviors/knowledge.svg';
import EngagementIcon from '../assets/behaviors/engagement.svg';
import PhishingClicksIcon from '../assets/behaviors/phishing-clicks.svg';
import PhishingReportsIcon from '../assets/behaviors/phishing-reports.svg';
import EmailSecurityIcon from '../assets/behaviors/email-security.svg';
import DataProtectionIcon from '../assets/behaviors/data-protection.svg';
import MicrosoftIdentityIcon from '../assets/behaviors/microsoft-identity.svg';

/**
 * Behavior icons taken from the CyberQ-Portal Figma. The SVGs use `currentColor`
 * so the row can tint them by sentiment (positive / negative / neutral).
 */
export const behaviorIcons: Record<ScoreBreakdownCategories, SVGRSvg> = {
  [ScoreBreakdownCategories.COMPLETION]: CompletionIcon,
  [ScoreBreakdownCategories.KNOWLEDGE]: KnowledgeIcon,
  [ScoreBreakdownCategories.ENGAGEMENT]: EngagementIcon,
  [ScoreBreakdownCategories.PHISHING_CLICKS]: PhishingClicksIcon,
  [ScoreBreakdownCategories.PHISHING_REPORTS]: PhishingReportsIcon,
  [ScoreBreakdownCategories.EMAIL_SECURITY]: EmailSecurityIcon,
  [ScoreBreakdownCategories.DATA_PROTECTION]: DataProtectionIcon,
  [ScoreBreakdownCategories.MICROSOFT_IDENTITY]: MicrosoftIdentityIcon,
};
